// extracted by mini-css-extract-plugin
export var aboutPagePeopleGrid = "about_page_people_grid-module--aboutPagePeopleGrid--WtLe1";